module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-6.5387a81e.svg";